import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeatureSection } from './components/FeatureSection';
import { DashboardPreview } from './components/DashboardPreview';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { Dashboard } from './pages/Dashboard';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/dashboard/*" element={<Dashboard data-id="element-4" />} data-id="element-3" />
          <Route path="/" element={<>
                <Header data-id="element-6" />
                <main className="flex-grow" data-id="element-7">
                  <HeroSection data-id="element-8" />
                  <FeatureSection data-id="element-9" />
                  <DashboardPreview data-id="element-10" />
                  <CTASection data-id="element-11" />
                </main>
                <Footer data-id="element-12" />
              </>} data-id="element-5" />
        </Routes>
      </div>
    </BrowserRouter>;
}